module.exports = "https://cdn01.riselinkedu.com/assets/lottie/img_5.6a64e72e.png";